import '@vidstack/react/player/styles/base.css'

import type { MediaPlayerInstance, MediaProviderAdapter } from '@vidstack/react'
import type { PlayerProps } from '../model/types'

import { useRef } from 'react'
import {
	isHLSProvider,
	MediaPlayer,
	MediaProvider,
	Poster,
} from '@vidstack/react'

import { VideoLayout } from './video-layout'

export function Player({ src, poster }: PlayerProps) {
	const player = useRef<MediaPlayerInstance>(null)

	function onProviderChange(provider: MediaProviderAdapter | null) {
		// We can configure provider's here.
		if (isHLSProvider(provider)) {
			provider.config = {}
		}
	}

	return (
		<MediaPlayer
			className='ring-media-focus aspect-video w-full overflow-hidden rounded-md bg-slate-900 font-sans text-white data-[focus]:ring-4'
			title='Sprite Fight'
			src={src}
			crossOrigin
			playsInline
			onProviderChange={onProviderChange}
			ref={player}
		>
			<MediaProvider>
				<Poster
					className='absolute inset-0 block h-full w-full rounded-md object-cover opacity-0 transition-opacity data-[visible]:opacity-100'
					src={poster}
				/>
			</MediaProvider>
			<VideoLayout />
		</MediaPlayer>
	)
}
